import { 
  statusComplaintStart,
  statusComplaintSuccess,
  statusComplaintFailure 
} from "./complaintSlice";
import { get, postCustom, put, remove } from "../../requestMethods"

export const ShowComplaintApi = () => async (dispatch: any) => {
  try {
    dispatch(statusComplaintStart())
    const res = await get("complaint");
    const resData = res.data.success
    if(resData) {
      dispatch(statusComplaintSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusComplaintFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusComplaintFailure(errData.err))
      return [errData.err]  
    }
  }
}

export const AddComplaintApi = (complaint: any) => async (dispatch: any) => {
  try {
    dispatch(statusComplaintStart())
    const response = await postCustom("complaint", complaint)
    const resData  = await response.data.success
    if(resData) {
      dispatch(statusComplaintSuccess(resData))
      return true;
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusComplaintFailure(formErrors))      
      return formErrors
    } else {
      dispatch(statusComplaintFailure(errData.err))      
      return [errData.err]
    }
  }
}

export const EditComplaintApi = (id: any, complaint: any) => async (dispatch: any) => {
  try {
    dispatch(statusComplaintStart())
    const response = await put(`complaint/${id}`, complaint);
    const resData = response.data.success
    if(resData) {
      dispatch(statusComplaintSuccess(resData))
      return true;
    }
  }catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusComplaintFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusComplaintFailure(errData.err))
      return [errData.err]
    }
  }
}

export const DeleteComplaintApi = (id: string) => async (dispatch: any) => {
  try {
    dispatch(statusComplaintStart());
    const response = await remove(`complaint/${id}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusComplaintSuccess(resData))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusComplaintFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusComplaintFailure(errData.err))
      return errData.err
    }
  }
}

export const clearComplaintsApi = (dispatch: any) => {
  dispatch(statusComplaintSuccess([]))
}